import { FC, useState } from 'react';
import s from './generatedCodesCard.module.scss';
import { GroupOfSecretCodesType } from '@services/drop/helpers';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { Button } from '@components/UIKit/Button/Button';
import moment from 'moment/moment';
import { useTranslation } from '@hooks/useTranslation';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import { toy } from '@prisma/client';
import { GeneratedCodesCardLoading } from '@components/Cards/GeneratedCodesCard/GeneratedCodesCardLoading';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const DownloadCodes = dynamic(import('@components/Modals/Variants/DownloadCodes/DownloadCodes').then(module => module.DownloadCodes), {
  ssr: false
});
interface Props extends GroupOfSecretCodesType {
  toyName: toy['name'];
  toySlug: toy['slug'];
}
export const GeneratedCodesCard: FC<Props> = ({
  id,
  amount,
  created,
  secretCodes,
  toyName,
  toySlug
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const {
    data: profile,
    isLoading
  } = useProfile();
  const clickHandler = () => {
    setIsOpenModal(true);
  };
  const closeHandler = () => {
    setIsOpenModal(false);
  };
  if (isLoading) return <GeneratedCodesCardLoading />;
  const date = moment(created).format('DD.MM.YYYY');
  const time = moment(created).format('HH:mm');
  return <>
            <div className={s.generatedCodesCard}>
                <Avatar srcSet={[{
        width: 40,
        height: 40,
        minMedia: 0
      }]} profile={profile} isLoading={isLoading} data-sentry-element="Avatar" data-sentry-source-file="GeneratedCodesCard.tsx" />
                <div className={s.generatedCodesCard__main}>
                    <div className={cn(s.generatedCodesCard__shortId, '_ellipsis')}>
                        {isLoading ? tr({
            id: 'btn.loading'
          }) : profile?.shortid}
                    </div>
                    <div className={s.generatedCodesCard__created}>
                        {tr({
            id: 'toy.page.history.date.text'
          }, {
            date,
            time
          })}
                    </div>
                </div>
                <div className={s.generatedCodesCard__right}>
                    <div className={s.generatedCodesCard__count}>
                        {secretCodes.length}
                    </div>
                    <Button id='default_button' size={'small'} color={'White'} icons={{
          left: {
            className: s.generatedCodesCard__arrow,
            name: 'arrow_down'
          }
        }} onClick={clickHandler} data-sentry-element="Button" data-sentry-source-file="GeneratedCodesCard.tsx" />
                </div>
            </div>
            <Modal isOpen={isOpenModal} onClose={closeHandler} data-sentry-element="Modal" data-sentry-source-file="GeneratedCodesCard.tsx">
                <DownloadCodes closeHandler={closeHandler} amount={amount} groupId={id} toyName={toyName} toySlug={toySlug} secretCodes={secretCodes.map(({
        code
      }) => code)} data-sentry-element="DownloadCodes" data-sentry-source-file="GeneratedCodesCard.tsx" />
            </Modal>
        </>;
};